export const PUSHES_LOAD_START = 'PUSHES_LOAD_START';
export const PUSHES_LOAD_FINISH = 'PUSHES_LOAD_FINISH';
export const PUSHES_LOAD_ERROR = 'PUSHES_LOAD_ERROR';

export const PUSHES_ADD_START = 'PUSHES_ADD_START';
export const PUSHES_ADD_FINISH = 'PUSHES_ADD_FINISH';
export const PUSHES_ADD_ERROR = 'PUSHES_ADD_ERROR';
